import { AntSelectOption, AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';
import { BaseOptionType } from '@rc-component/select/lib/Select';
import { getLabelField } from 'controls/react/ant/ant-select/utils/getLabelField';
import { useMemo } from 'react';
import { sortByField } from 'controls/react/ant/ant-select/hooks/useSortedValues';

export function useSortedOptions<VT extends AntSelectValue, OptionType extends BaseOptionType>(
	props: AntSelectPropsGeneric<VT, OptionType>,
) {
	const { sortOptions, options, ...rest } = props;

	// sorting only makes sense against a single field - optionFilterProp can list several
	// (antd searches across all of them), so just use the first one as the sort key
	//const optionFilterProps = typeof showSearch == 'object' ? showSearch.?
	//const sortField = Array.isArray(props.showSearch?.optionFilterProp) ? props.optionFilterProp[0] : props.optionFilterProp;

	const sortField = getLabelField(props);

	const sortedOptions = useMemo(() => {
		if (sortOptions == false || !options) return options;

		const optionsCopy = [...options];
		const onTop = optionsCopy
			.filter((x: AntSelectOption) => x.order != undefined)
			.sort((a: AntSelectOption, b: AntSelectOption) => sortByField(a, b, 'order'));
		const others = optionsCopy
			.filter((x: AntSelectOption) => x.order == undefined)
			.sort((a: AntSelectOption, b: AntSelectOption) => sortByField(a, b, sortField));
		return [...onTop, ...others];
	}, [sortOptions, options, sortField]);

	return {
		options: sortedOptions,
		...rest,
	};
}
